import React from 'react';
import { Hourglass } from 'lucide-react';
export function UrgencyBar() {
  return <div className="absolute bottom-0 left-0 w-full z-20 flex h-12" data-id="element-250">
      {/* Left Black Section with Angled Cut */}
      <div className="relative bg-black text-white flex items-center px-8 md:px-16 z-10" data-id="element-251">
        <div className="flex items-center gap-2 font-bold text-red-500 text-lg" data-id="element-252">
          <Hourglass className="w-5 h-5 text-white" data-id="element-253" />
          <span data-id="element-254">Only 72 left</span>
        </div>

        {/* Angled Edge using CSS borders or clip-path */}
        <div className="absolute top-0 right-0 h-full w-12 bg-black translate-x-1/2 skew-x-[20deg] z-[-1]" data-id="element-255"></div>
        <div className="absolute top-0 right-0 h-full w-6 bg-black translate-x-full" style={{
        clipPath: 'polygon(0 0, 0% 100%, 100% 100%)'
      }} data-id="element-256"></div>
      </div>

      {/* Right Gray Section */}
      <div className="flex-1 bg-slate-500/80 backdrop-blur-sm flex items-center justify-center md:justify-start pl-12 md:pl-24 text-white font-medium text-lg" data-id="element-257">
        Hurry before the price goes back up!
      </div>
    </div>;
}